// extracted by mini-css-extract-plugin
export default {"contry":"styles_contry__xnBzi"};